"use client"

import React, { useRef } from "react"

import { useState, useEffect } from "react"
import { motion, AnimatePresence } from "framer-motion"
import {
    Shield, Lock, Star, Crown, CheckCircle, AlertTriangle, User, Mail, Phone, Eye,
    XCircle, AlertCircle
} from "lucide-react"
import PhoneInput, { isValidPhoneNumber } from 'react-phone-number-input';
import '../events/inputStyle.css';
import { Toast } from '../../components/Toast';
import { Button } from "../../components/ui/button"
import { Card, CardContent, CardHeader } from "../../components/ui/card"
import { Badge } from "../../components/ui/badge"
import { Input } from "../../components/ui/input"
import Receipt from "../../components/Receipt";

// interface FormData {
//   firstName: string
//   surname: string
//   email: string
//   phone: string
// }

// interface FormErrors {
//   firstName?: string
//   surname?: string
//   email?: string
//   phone?: string
// }

export default function VIPRegistration() {
    const [formData, setFormData] = useState({
        firstName: "",
        surname: "",
        email: "",
        phone: "",
    })
    const [form, setForm] = useState({
        first_name: "",
        surname: "",
        email_address: "",
        phone_number: "",
        volunteer: "",
        vip: "true",
        isEmailAvailable: false,
        isPhoneValid: false,
    });
    const [errors, setErrors] = useState({})
    // const [isSubmitting, setIsSubmitting] = useState(false)
    const [isSubmitted, setIsSubmitted] = useState(false)
    const [showPrivacyNotice, setShowPrivacyNotice] = useState(true)
    const [registrants, setRegistrants] = useState([]);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isRegistefuchsia, setIsRegistefuchsia] = useState(false);

    // const validateForm = () => {
    //     const newErrors = {}

    //     if (!formData.firstName.trim()) {
    //         newErrors.firstName = "First name is requifuchsia"
    //     }

    //     if (!formData.surname.trim()) {
    //         newErrors.surname = "Surname is requifuchsia"
    //     }

    //     if (!formData.email.trim()) {
    //         newErrors.email = "Email address is requifuchsia"
    //     } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
    //         newErrors.email = "Please enter a valid email address"
    //     }

    //     if (!formData.phone.trim()) {
    //         newErrors.phone = "Phone number is requifuchsia"
    //     } else if (!/^[+]?[1-9][\d]{0,15}$/.test(formData.phone.replace(/[\s\-$$$$]/g, ""))) {
    //         newErrors.phone = "Please enter a valid phone number"
    //     }

    //     setErrors(newErrors)
    //     return Object.keys(newErrors).length === 0
    // }

    // const handleInputChange = (field, value) => {
    //     setFormData((prev) => ({ ...prev, [field]: value }))
    //     // Clear error when user starts typing
    //     if (errors[field]) {
    //         setErrors((prev) => ({ ...prev, [field]: undefined }))
    //     }
    // }

    // const handleSubmit__ = async (e) => {
    //     e.preventDefault()

    //     if (!validateForm()) return

    //     setIsSubmitting(true)

    //     try {
    //         // Simulate API call
    //         await new Promise((resolve) => setTimeout(resolve, 2000))

    //         // Here you would typically send the data to your backend
    //         console.log("VIP Registration Data:", formData)

    //         setIsSubmitted(true)
    //     } catch (error) {
    //         console.error("Registration failed:", error)
    //     } finally {
    //         setIsSubmitting(false)
    //     }
    // }



    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);

        if (form.isEmailAvailable === false) {
            Toast.error('Email is already in use. Please use another email.');
            setIsSubmitting(false);
            return;
        }

        if (form.isEmailAvailable === null) {
            Toast.error('Unable to verify email. Please check your connection and try again.');
            setIsSubmitting(false);
            return;
        }

        if (!form.isPhoneValid) {
            Toast.error('Your Phone number is not valid.');
            setIsSubmitting(false);
            return;
        }

        // Proceed to submit
        try {
            const response = await fetch("https://tsoministries.com/wp-json/custom-form/v1/thp", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(form),
            });

            const result = await response.json();
            if (response.ok) {
                sendEmail([{ id: 1600, email_address: form.email_address }]);
                setTimeout(() => {
                    Toast.success("Registration successful! We'll be in touch soon.");
                    setIsSubmitting(false);
                    setIsRegistefuchsia(true);
                }, 2000);
                // setForm({
                //     first_name: "",
                //     surname: "",
                //     email_address: "",
                //     phone_number: "",
                //     isEmailAvailable: null,
                //     isPhoneValid: false,
                // });
            } else {
                Toast.success("Something went wrong, Please post this issue in our issues page");
                setTimeout(() => {
                    setIsSubmitting(false);
                    throw new Error(result.message || 'Something went wrong');
                }, 600);
            }
        } catch (error) {
            Toast.error(error.message || 'Failed to submit form');
            setIsSubmitting(false);
        } finally {
            setTimeout(() => {
                setIsSubmitting(false);
            }, 2000);
        }
    };

    const sendEmail = async (registrants) => {
        for (const registrant of registrants) {
            try {
                const res = await fetch('https://tsoministries.com/wp-json/custom-api/v1/send-thp-invite', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(registrant),
                });

                if (!res.ok) throw new Error(`Failed to send to ${registrant.email_address}`);
                // setSent(prev => [...prev, registrant]);
            } catch (err) {
                console.error(err);
                // setFailed(prev => [...prev, registrant]);
            }
        }
    };



    if (isRegistefuchsia) {
        return <SuccessPage formData={form} />
    }

    return (
        <div className="min-h-screen bg-gradient-to-br from-gray-900 via-gray-800 to-black relative overflow-hidden pt-[10vh]">
            {/* Background Elements */}
            <div className="absolute inset-0">
                <div className="absolute top-0 left-0 w-full h-full opacity-10">
                    <div className="absolute top-20 left-20 w-64 h-64 bg-gradient-to-r from-fuchsia-400 to-rose-500 rounded-full blur-3xl"></div>
                    <div className="absolute bottom-20 right-20 w-96 h-96 bg-gradient-to-r from-purple-500 to-pink-500 rounded-full blur-3xl"></div>
                    <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-80 h-80 bg-gradient-to-r from-blue-500 to-cyan-500 rounded-full blur-3xl opacity-50"></div>
                </div>
            </div>

            <div className="relative z-10 container mx-auto px-4 py-8 min-h-screen flex flex-col items-center justify-center">
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8 }}
                    className="flex md:hidden w-full max-w-2xl"
                >
                    {/* Privacy Notice */}
                    <AnimatePresence>
                        {showPrivacyNotice && (
                            <motion.div
                                initial={{ opacity: 0, y: -20 }}
                                animate={{ opacity: 1, y: 0 }}
                                exit={{ opacity: 0, y: -20 }}
                                className="mb-6"
                            >
                                <Card className="border-fuchsia-500/20 bg-fuchsia-50/10 backdrop-blur-sm">
                                    <CardContent className="p-4">
                                        <div className="flex items-start gap-3">
                                            <AlertTriangle className="w-5 h-5 text-fuchsia-400 mt-0.5 flex-shrink-0" />
                                            <div className="flex-1">
                                                <h3 className="text-fuchsia-200 font-semibold mb-1">Private & Confidential</h3>
                                                <p className="text-fuchsia-100/80 text-sm leading-relaxed">
                                                    This is an exclusive VIP registration link. Please do not share this link with anyone,
                                                    including friends and family members. This invitation is personal and confidential.
                                                </p>
                                            </div>
                                            <button
                                                onClick={() => setShowPrivacyNotice(false)}
                                                className="text-fuchsia-300 hover:text-fuchsia-200 transition-colors"
                                            >
                                                <Eye className="w-4 h-4" />
                                            </button>
                                        </div>
                                    </CardContent>
                                </Card>
                            </motion.div>
                        )}
                    </AnimatePresence>
                </motion.div>

                {/* Main Registration Card */}
                <div className="grid md:grid-cols-2 gap-12 items-start min-h-screen">
                    <Card className="border-fuchsia-500/20 bg-white/5 backdrop-blur-xl shadow-2xl">
                        <CardHeader className="text-center pb-8">
                            <motion.div
                                initial={{ scale: 0.8, opacity: 0 }}
                                animate={{ scale: 1, opacity: 1 }}
                                transition={{ delay: 0.2, duration: 0.5 }}
                                className="flex items-center justify-center gap-3 mb-4"
                            >
                                <div className="relative flex items-center justify-center">
                                    {/* <Crown className="w-8 h-8 text-fuchsia-400" /> */}
                                    <div className="absolute -top-1 w-3 h-3 bg-fuchsia-400 rounded-full animate-pulse"></div>
                                </div>
                                <Badge className="bg-gradient-to-r from-fuchsia-500 to-rose-500 text-white px-4 py-1 text-sm font-semibold">
                                    VIP INVITE
                                </Badge>
                                <div className="relative flex items-center justify-center">
                                    {/* <Crown className="w-8 h-8 text-fuchsia-400" /> */}
                                    <div className="absolute -top-1 w-3 h-3 bg-fuchsia-400 rounded-full animate-pulse"></div>
                                </div>
                            </motion.div>

                            <h1 className="text-3xl md:text-4xl font-bold text-white mb-2">Exclusive Registration</h1>

                            {/* <div className="flex items-center justify-center gap-6 mt-6 text-sm text-gray-400">
                                <div className="flex items-center gap-2">
                                    <Shield className="w-4 h-4 text-green-400" />
                                    <span>Secure</span>
                                </div>
                                <div className="flex items-center gap-2">
                                    <Lock className="w-4 h-4 text-blue-400" />
                                    <span>Private</span>
                                </div>
                                <div className="flex items-center gap-2">
                                    <Star className="w-4 h-4 text-fuchsia-400" />
                                    <span>Exclusive</span>
                                </div>
                            </div> */}
                            
                            <p className="text-gray-300 text-lg">The Healing Party - VIP Registration</p>
                        </CardHeader>

                        <CardContent className="px-8 pb-8">
                            <form onSubmit={handleSubmit} className="space-y-6">
                                {/* First Name */}
                                <div className="space-y-2">
                                    <label htmlFor="firstName" className="text-sm font-medium text-gray-200 flex items-center gap-2">
                                        <User className="w-4 h-4" />
                                        First Name
                                    </label>
                                    <input
                                        type="text"
                                        name="first_name"
                                        value={form.first_name}
                                        onChange={handleChange}
                                        className="w-full pl-10 pr-4 py-3 text-white bg-white/5 rounded-lg border border-white/10 focus:outline-none focus:ring-2 focus:ring-fuchsia-500 focus:border-transparent transition-all duration-300"
                                        requifuchsia
                                    />
                                </div>

                                {/* Surname */}
                                <div className="space-y-2">
                                    <label htmlFor="surname" className="text-sm font-medium text-gray-200 flex items-center gap-2">
                                        <User className="w-4 h-4" />
                                        Surname
                                    </label>
                                    <input
                                        type="text"
                                        name="surname"
                                        value={form.surname}
                                        onChange={handleChange}
                                        className="w-full pl-10 pr-4 py-3 text-white bg-white/5 rounded-lg border border-white/10 focus:outline-none focus:ring-2 focus:ring-fuchsia-500 focus:border-transparent transition-all duration-300"
                                        requifuchsia
                                    />
                                </div>

                                {/* Email */}
                                <div className="space-y-2">
                                    <label htmlFor="email" className="text-sm font-medium text-gray-200 flex items-center gap-2">
                                        <Mail className="w-4 h-4" />
                                        Email Address
                                    </label>
                                    <THPEmailInput
                                        value={form.email_address}
                                        onChange={(e) => handleChange(e)}
                                        setForm={setForm}
                                    />
                                </div>

                                {/* Phone */}
                                <div className="space-y-2">
                                    <label htmlFor="phone" className="text-sm font-medium text-gray-200 flex items-center gap-2">
                                        <Phone className="w-4 h-4" />
                                        Phone Number
                                    </label>
                                    <THPPhoneInput
                                        value={form.phone_number}
                                        onChange={(e) => handleChange(e)}
                                        setForm={setForm}
                                    />
                                </div>

                                {/* Submit Button */}
                                <motion.div whileHover={{ scale: 1.02 }} whileTap={{ scale: 0.98 }} className="pt-4">
                                    <Button
                                        type="submit"
                                        disabled={isSubmitting}
                                        className="w-full bg-gradient-to-r from-fuchsia-500 to-rose-500 hover:from-fuchsia-600 hover:to-rose-600 text-white font-semibold py-3 text-lg shadow-lg hover:shadow-xl transition-all duration-300"
                                    >
                                        {isSubmitting ? (
                                            <div className="flex items-center gap-2">
                                                <div className="w-5 h-5 border-2 border-white/30 border-t-white rounded-full animate-spin"></div>
                                                Registering...
                                            </div>
                                        ) : (
                                            <div className="flex items-center gap-2">
                                                <Crown className="w-5 h-5" />
                                                Confirm VIP Registration
                                            </div>
                                        )}
                                    </Button>
                                </motion.div>
                            </form>

                            {/* Footer Notice */}
                            <div className="mt-8 pt-6 border-t border-white/10">
                                <p className="text-center text-gray-400 text-sm">
                                    By registering, you confirm your exclusive invitation to The Healing Party.
                                    <br />
                                    <span className="text-fuchsia-400">August 28, 2026 | 02:00 PM</span>
                                </p>
                            </div>
                        </CardContent>
                    </Card>

                    <div>
                        {/* Privacy Notice */}
                        <AnimatePresence>
                            {showPrivacyNotice && (
                                <motion.div
                                    initial={{ opacity: 0, y: -20 }}
                                    animate={{ opacity: 1, y: 0 }}
                                    exit={{ opacity: 0, y: -20 }}
                                    className="hidden md:flex mb-6"
                                >
                                    <Card className="border-fuchsia-500/20 bg-fuchsia-50/10 backdrop-blur-sm">
                                        <CardContent className="p-4">
                                            <div className="flex items-start gap-3">
                                                <AlertTriangle className="w-5 h-5 text-fuchsia-400 mt-0.5 flex-shrink-0" />
                                                <div className="flex-1">
                                                    <h3 className="text-fuchsia-200 font-semibold mb-1">Private & Confidential</h3>
                                                    <p className="text-fuchsia-100/80 text-sm leading-relaxed">
                                                        This is an exclusive VIP registration link. Please do not share this link with anyone,
                                                        including friends and family members. This invitation is personal and confidential.
                                                    </p>
                                                </div>
                                                <button
                                                    onClick={() => setShowPrivacyNotice(false)}
                                                    className="text-fuchsia-300 hover:text-fuchsia-200 transition-colors"
                                                >
                                                    <Eye className="w-4 h-4" />
                                                </button>
                                            </div>
                                        </CardContent>
                                    </Card>
                                </motion.div>
                            )}
                        </AnimatePresence>

                        {/* Event Flyer */}
                        <motion.div
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            transition={{ delay: 0.8 }}
                            className="relative aspect-[4/4] md:aspect-[4/5] md:block flex justify-center items-center bg-black overflow-hidden rounded-3xl mb-8 md:mb-0"
                        >
                            <img
                                src={"https://tsoministries.com/wp-content/uploads/2026/08/THP26-Updated-scaled.png"}
                                alt="Healing Party"
                                className="relative w-full h-full object-cover"
                            />
                        </motion.div>
                    </div>
                </div>
            </div>
        </div>
    )
}

// Success Page Component
function SuccessPage({ formData }) {
    const [downloadReceipt, set_downloadReceipt] = useState(false)

    return (
        <div className="min-h-screen bg-gradient-to-br from-gray-900 via-gray-800 to-black relative overflow-hidden flex items-center justify-center py-24">
            {/* Background Elements */}
            <div className="absolute inset-0">
                <div className="absolute top-0 left-0 w-full h-full opacity-10">
                    <div className="absolute top-20 left-20 w-64 h-64 bg-gradient-to-r from-green-400 to-emerald-500 rounded-full blur-3xl"></div>
                    <div className="absolute bottom-20 right-20 w-96 h-96 bg-gradient-to-r from-fuchsia-500 to-rose-500 rounded-full blur-3xl"></div>
                </div>
            </div>

            <div className="relative z-10 container mx-auto px-4">
                <motion.div
                    initial={{ opacity: 0, scale: 0.8 }}
                    animate={{ opacity: 1, scale: 1 }}
                    transition={{ duration: 0.8 }}
                    className="max-w-2xl mx-auto text-center"
                >
                    <Card className="border-green-500/20 bg-white/5 backdrop-blur-xl shadow-2xl">
                        <CardContent className="p-2 md:p-12">
                            <motion.div
                                initial={{ scale: 0 }}
                                animate={{ scale: 1 }}
                                transition={{ delay: 0.3, type: "spring", stiffness: 200 }}
                                className="mb-8"
                            >
                                <div className="w-20 h-20 bg-gradient-to-r from-green-400 to-emerald-500 rounded-full flex items-center justify-center mx-auto mb-6">
                                    <CheckCircle className="w-10 h-10 text-white" />
                                </div>
                            </motion.div>

                            <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.5 }}>
                                <h1 className="text-4xl font-bold text-white mb-4">Registration Confirmed!</h1>
                                <p className="text-xl text-gray-300 mb-8">Thank you for registering, {formData.first_name}! Please Download Your Receipt</p>

                                <Receipt formData={formData} downloadReceipt={downloadReceipt} set_downloadReceipt={set_downloadReceipt} />

                                <div className="bg-white/10 rounded-lg p-6 mb-8">
                                    <h3 className="text-lg font-semibold text-fuchsia-400 mb-4">What's Next?</h3>
                                    <div className="space-y-3 text-left">
                                        <div className="flex items-center gap-3 text-gray-300">
                                            <div className="w-2 h-2 bg-fuchsia-400 rounded-full"></div>
                                            <span>Download your receipt now before the page refreshes.</span>
                                        </div>
                                        <div className="flex items-center gap-3 text-gray-300">
                                            <div className="w-2 h-2 bg-fuchsia-400 rounded-full"></div>
                                            <span>You'll receive a confirmation email within 24 hours</span>
                                        </div>
                                        <div className="flex items-center gap-3 text-gray-300">
                                            <div className="w-2 h-2 bg-fuchsia-400 rounded-full"></div>
                                            <span>VIP access details will be sent closer to the event</span>
                                        </div>
                                    </div>
                                </div>

                                <div className="text-center">
                                    <div onClick={()=> set_downloadReceipt(true)} className="cursor-pointer">
                                        <Badge className="bg-gradient-to-r from-fuchsia-500 to-rose-500 text-white px-6 py-2 text-lg font-semibold mb-4">
                                            DOWNLOAD RECEIPT
                                        </Badge>
                                    </div>
                                    <p className="text-gray-400">
                                        The Healing Party - VIP Experience
                                        <br />
                                        <span className="text-fuchsia-400 font-semibold">August 28, 2026 | 02:00 PM</span>
                                    </p>
                                </div>
                            </motion.div>
                        </CardContent>
                    </Card>
                </motion.div>
            </div>
        </div>
    )
}








// ---------------------------
// THPPhoneInput component
// ---------------------------
const THPPhoneInput = ({ value, onChange, setForm }) => {
    const [phone, setPhone] = useState(value || "");
    const [isValid, setIsValid] = useState(true);

    useEffect(() => {
        if (!phone) {
            setIsValid(true);
            setForm((prev) => ({ ...prev, isPhoneValid: false }));
            return;
        }

        const valid = isValidPhoneNumber(phone);
        setIsValid(valid);

        setForm((prev) => ({ ...prev, isPhoneValid: valid }));
    }, [phone, setForm]);

    const handleChange = (value) => {
        setPhone(value);
        onChange({ target: { name: "phone_number", value } });
    };

    return (
        <div className="mb-6">
            {/* <label className="block text-sm font-medium mb-2">Phone Number</label> */}
            <div className="relative">
                <PhoneInput
                    international
                    defaultCountry="NG" // Nigeria by default
                    value={phone}
                    onChange={handleChange}
                    className="w-full pl-5 text-white bg-white/5 rounded-lg border border-white/10 focus:outline-none focus:ring-2 focus:ring-fuchsia-500 focus:border-transparent transition-all duration-300"
                />
                {phone && (
                    <div className="absolute right-3 top-1/2 transform -translate-y-1/2">
                        {isValid ? (
                            <CheckCircle className="text-green-500 w-5 h-5" />
                        ) : (
                            <XCircle className="text-red-500 w-5 h-5" />
                        )}
                    </div>
                )}
            </div>

            {!isValid && phone?.length > 0 && (
                <p className="text-red-500 text-sm mt-1">
                    Invalid phone number, make sure your number is in the correct format +234 809 999 9999
                </p>
            )}
        </div>
    );
};

// ---------------------------
// THPEmailInput component
// ---------------------------
const THPEmailInput = ({ value, onChange, setForm }) => {
    const [email, setEmail] = useState(value || "");
    const [isValid, setIsValid] = useState(true);
    const [isAvailable, setIsAvailable] = useState(null);
    const [showEmailWarning, setShowEmailWarning] = useState(false);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (!email) {
            setIsValid(true);
            setIsAvailable(null);
            return;
        }

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const isEmailValid = emailRegex.test(email);
        setIsValid(isEmailValid);
        setShowEmailWarning(true);

        if (!isEmailValid) {
            setIsAvailable(null);
            return;
        }

        const delay = setTimeout(async () => {
            setLoading(true);
            try {
                const available = await checkEmailAvailability(email);
                setIsAvailable(available);
            } catch (error) {
                console.error("Error checking email availability:", error);
                setIsAvailable(null); // Force null on any error
            } finally {
                setLoading(false);
            }
        }, 500);

        return () => clearTimeout(delay);
    }, [email]);

    // Always update parent form with current email availability
    useEffect(() => {
        if (!email) {
            setForm(prev => ({ ...prev, isEmailAvailable: null }));
            return;
        }

        if (isValid) {
            setForm(prev => ({ ...prev, isEmailAvailable: isAvailable }));
        } else {
            setForm(prev => ({ ...prev, isEmailAvailable: false }));
        }
    }, [email, isValid, isAvailable, setForm]);

    const handleChange = (e) => {
        setEmail(e.target.value);
        onChange({ target: { name: "email_address", value: e.target.value } });
    };

    return (
        <div className="mb-6">
            {/* <label className="block text-sm font-medium mb-2">Email Address</label> */}
            <div className="relative">
                <Mail className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
                <input
                    type="email"
                    name="email_address"
                    value={email}
                    onChange={handleChange}
                    className="w-full pl-10 pr-4 py-3 text-white bg-white/5 rounded-lg border border-white/10 focus:outline-none focus:ring-2 focus:ring-fuchsia-400 focus:border-transparent transition-all duration-300"
                    requifuchsia
                />
                {loading ? (
                    <div className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400">
                        Checking...
                    </div>
                ) : showEmailWarning && isValid && (
                    <div className="absolute right-3 top-1/2 transform -translate-y-1/2">
                        {isAvailable === true ? (
                            <CheckCircle className="text-green-500 w-5 h-5" />
                        ) : isAvailable === false ? (
                            <XCircle className="text-red-500 w-5 h-5" />
                        ) : email.length >= 1 && (
                            <AlertCircle className="text-yellow-500 w-5 h-5" />
                        )}
                    </div>
                )}
            </div>

            {showEmailWarning && !isValid && email.length > 0 && (
                <p className="text-red-500 text-sm mt-1">Invalid email format.</p>
            )}

            {showEmailWarning && isValid && isAvailable === false && (
                <p className="text-red-500 text-sm mt-1">
                    This email is already in use. You are registefuchsia already.
                </p>
            )}

            {email.length >= 1 && showEmailWarning && isValid && isAvailable === null && !loading && (
                <p className="text-yellow-500 text-sm mt-1">
                    Unable to verify email. Please check your internet connection.
                </p>
            )}
        </div>
    );
};

// -----------------------------------------
// checkEmailAvailability (utility function)
// -----------------------------------------
async function checkEmailAvailability(email) {
    const endpoint = 'https://tsoministries.com/wp-json/wp/v2/thp';
    let page = 1;
    let emailExists = false;

    try {
        while (true) {
            const response = await fetch(`${endpoint}?per_page=100&page=${page}&_fields=id,email_address`);

            if (!response.ok) {
                // If 400 and page > 1, assume we've reached the end
                if (response.status === 400 && page > 1) {
                    break;
                }
                throw new Error(`Error fetching page ${page}`);
            }

            const data = await response.json();

            if (!Array.isArray(data) || data.length === 0) {
                break;
            }

            for (const item of data) {
                if (item.email_address && item.email_address.toLowerCase() === email.toLowerCase()) {
                    emailExists = true;
                    break;
                }
            }

            if (emailExists || data.length < 100) {
                break;
            }

            page++;
        }

        return !emailExists; // true = available
    } catch (error) {
        console.error('Failed to check email v2:', error);
        return null;
    }
}